import FairePdpProductReviewsPage from "@faire/prototype-playground/workspace/jba/faire-pdp-product-reviews";
import FairePdpReviewPlacementsPage from "@faire/prototype-playground/workspace/jba/faire-pdp-review-placements";
import FaireSourceProductReviewsPage from "@faire/prototype-playground/workspace/jba/faire-source-product-reviews";
import { Route, Switch } from "react-router-dom";

export function JamesBaoRoutes() {
  return (
    <Switch>
      <Route
        path="/jba/faire-pdp-product-reviews"
        component={FairePdpProductReviewsPage}
      />
      <Route
        path="/jba/faire-pdp-review-placements"
        component={FairePdpReviewPlacementsPage}
      />
      <Route
        path="/jba/faire-source-product-reviews"
        component={FaireSourceProductReviewsPage}
      />
    </Switch>
  );
}

export const slug = "jba";
